import React from 'react';
import styled from 'styled-components';
import { X } from 'react-feather';

const Modal = ({
    children,
    state,
    setState,
    handleClose,
    title,
    showHeader = true,
    showOverlay = true,
    modalPosition,
    padding,
    justifyContent,
    headerPadding,
    textAlign,
    overflow
}) => {
    return (
        <>
            {state &&
                <Overlay showOverlay={showOverlay} modalPosition={modalPosition} textAlign={textAlign} overflow={overflow}>
                    <ContainerModal padding={padding}>
                        {showHeader &&
                            <HeaderModal headerPadding={headerPadding}>
                                <h3>{title}</h3>
                            </HeaderModal>
                        }
                        <CloseButton onClick={() => handleClose ? handleClose() : setState(false)}>
                            <svg>
                                <title>Cerrar</title>
                                <g><X /></g>
                            </svg>
                        </CloseButton>
                        <Content justifyContent={justifyContent}>
                            {children}
                        </Content>
                    </ContainerModal>
                </Overlay>
            }
        </>
    );
}

export default Modal;

const Overlay = styled.div`
    width: 100vw;
    height: 100vh;
    position:fixed;
    top: 0;
    left: 0;
    background: ${props => props.showOverlay ? 'rgba(0,0,0,.5)' : 'rgba(0,0,0,0)'};
    display:flex;
    align-items:${props => props.modalPosition ? props.modalPosition : 'center'};
    justify-content:center;
    text-align:${props => props.textAlign ? props.textAlign : 'center'};
    z-index:10;
    overflow:${props => props.overflow ? props.overflow : 'hidden'};
`;

const ContainerModal = styled.div`
    width: 35%;
    background: var(--color-blanco);
    position:relative;
    border-radius:5px;
    box-shadow: rgba(100,100,111,0.2) 0px 7px 29px 0px;
    padding:${props => props.padding ? props.padding : '24px'};
    max-height:70vh;
    overflow:auto;
`;

const Content = styled.div`
    display:flex;
    width:100%;
    justify-content:${props => props.justifyContent ? props.justifyContent : 'center'};
`;

const HeaderModal = styled.div`
    display:flex;
    align-items:center;
    justify-content:space-between;
    border-bottom: 1px solid var(--color-gris-claro);
    padding: ${props => props.headerPadding ? props.headerPadding : '0 0 16px 0'};
    h3{
        font-weight:700;
        font-size:18px;
        margin:0;
        color: var(--color-morado-oscuro);
    }
`;

const CloseButton = styled.div`
    position: absolute;
    top:16px;
    right:16px;
    width: 24px;
    height: 24px;
    border: none;
    background: none;
    cursor: pointer;
    transition: .3s ease all;
    border-radius: 5px;
    color: var(--color-morado-oscuro);

    &:hover{
        background: var(--color-gris-claro);
    }
    svg{
        width:100%;
        height:100%;
    }
`;




